export const Building = require('./building.png');
export const Ikea = require('./ikea.png');
export const Laudes = require('./laudes.jpg');